import type { PlatformPlugin } from "./PlatformPlugin";
import OfficePlugin from "./plugins/office";
import DynamicsIframePlugin from "./plugins/dynamicsIframe";
import SalesforcePlugin from "./plugins/salesforce";
import C4cPlugin from "./plugins/c4c";
import WebPlugin from "./plugins/web";
import { bootPlatformRuntime } from "./runtime/PlatformRuntime";
import { resolveFrameSessionPersistence } from "./sessionPersistence";

import type { PlatformName } from "./types";
export type { PlatformName };

const plugins: PlatformPlugin[] = [OfficePlugin, DynamicsIframePlugin, SalesforcePlugin, C4cPlugin, WebPlugin];

/**
 * Detects and boots the most appropriate platform plugin for the current host.
 */
export async function bootPlatform() {
  const runtime = await bootPlatformRuntime(plugins);

  return {
    plugin: runtime.plugin.name,
    bridge: runtime.bridge,
    persistSessionInFrame: await resolveFrameSessionPersistence(runtime.plugin),
  } as const;
}
